import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@features/auth/store/authStore';
import { SESSION_STORAGE_KEYS } from '@features/auth/constants/sessionStorageKeys';

const ProtectedRouteSimple: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());
  const location = useLocation();

  if (!isAuthenticated) {
    const isExplicitLogout =
      sessionStorage.getItem(SESSION_STORAGE_KEYS.EXPLICIT_LOGOUT) === '1';
    // Save the intended URL so we can redirect after login (skip on explicit Sign out)
    const intendedPath = location.pathname + location.search;
    if (!isExplicitLogout && intendedPath !== '/entities') {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.REDIRECT_AFTER_LOGIN, intendedPath);
    }
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRouteSimple;